import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import DashboardComponent from "../../components/dashboard";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { getSkinProfileApi } from "../../services/skinProfile.service";
import { getSkincareStepsApi } from "../../services/skincare.service";
import PageLoader from "../../components/common/loader/pageLoader";
import { getProfileApi } from "../../services/profile.service";

interface DashboardContainerInterface {}

const DashboardContainer: React.FC<DashboardContainerInterface> = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [currentSkincare, setCurrentSkincare] = useState();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const params = useLocation().search;
  const token = new URLSearchParams(params).get("token");

  const fetchSkinProfile = () => {
    setLoading(true);
    dispatch(
      getSkinProfileApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data: any) => {
          setData(data);
        },
        unAunthicatedCallback: () => {
          // localStorage.clear();
          // navigate("/login");
        },
      })
    );
  };

  const fetchCurrentSkincare = () => {
    setLoading(true);
    dispatch(
      getSkincareStepsApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (currentSkincare: any) => {
          setCurrentSkincare(currentSkincare);
        },
      })
    );
  };

  const fetchProfile = () => {
    dispatch(
      getProfileApi({
        finalCallback: () => {},
        successCallback: () => {},
        unauthenticatedCallback: () => {},
      })
    );
  };

  useEffect(() => {
    if (token != null) {
      localStorage.setItem("alrounderToken", token);
    }
    console.log("token here");
    fetchProfile();
    fetchSkinProfile();
    fetchCurrentSkincare();
  }, [token]);

  if (loading) {
    return <PageLoader />;
  }

  return <DashboardComponent data={data} currentSkincare={currentSkincare} />;
};

export default DashboardContainer;
